module.exports = __webpack_public_path__ + "flags@2x.png?d429a5777afaf2fc349652e812e9bb11";